import {clearLoadingMessage, setLoadingMessage} from '../actions';
import * as ActionTypes from '../actions/actionTypes';
import {populateBoundaryAsync} from '../actions/populate_boundary_details';

export const orchestrateBoundaryData = store => next => action => {
  switch (action.type) {

    case ActionTypes.TOGGLE_BOUNDARY:
    case ActionTypes.ACTIVATE_BOUNDARY:
      const { boundaries } = store.getState();
      boundaries.layers
                .filter(boundary => boundary.prefix === action.layer_prefix &&
                                    boundary.type === 'geojson' &&
                                    !boundary.geojson)
                .forEach(boundary => {
                  store.dispatch(setLoadingMessage('Loading boundary data...'));
                  store.dispatch(populateBoundaryAsync(boundary));
                });
      break;

    case ActionTypes.POPULATE_BOUNDARY_DATA:
      store.dispatch(clearLoadingMessage());
      break;

    default:
      break;
  }

  return next(action);
};



// WEBPACK FOOTER //
// ./src/middleware/boundariesMiddleware.js